import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import {
  BroadcastPresetShow,
  DynamicPromoShow,
  LayoutShow,
  LiveShow,
  MediaShow,
  Show,
} from "../../domain/show";
import moment from "moment";
import { CalendarView } from "./calendar-view";
import { UI } from "../../services/ui.service";
import { ContextMenuComponent } from "@perfectmemory/ngx-contextmenu";
import { UserService } from "../../domain/user-service";
import { ConversionUtils } from "../../domain/conversion-utils";
import { Observable, Subject, Subscription } from "rxjs";
import { Router } from "@angular/router";
import { NgxSmartModalService } from "ngx-smart-modal";
import { MediaInfo, MediaItem, MediaSegment } from "../../domain/media";
import { LiveFeedInfo } from "../../domain/live-feed";
import { Socket } from "../../infrastructure/socket.service";
import { MediaRepository } from "../../domain/media-repository";
import { ShowRepository } from "../../domain/show-repository";
import { CalendarService } from "../../domain/calendar-service";
import { DynamicPromoInfo } from "../../domain/dyanmicPromo";
import { CalendarSearchService } from "./services/calendar-search.service";
import { FuturePreviewViewModel } from "../channel/future-preview/future-preview.view-model";
import { TenantService } from "../../services/tenant.service";
import { TenantSettings } from "../../domain/tenant-settings";
import Color from "color";
import { SecEventType } from "../../domain/sec-events";
import { SecEventsService } from "./expandable/sec-events.service";
import { SecEventCategory } from "../../domain/sec-event-category";
import { CalendarItem } from "./calendar-item";
import { Channel } from "../../domain/channel";
import { CopyShowsViewModel } from "../../services/show/copy-shows.view-model";
import { Layout } from "../../domain/layouts/layout";
import { ELayoutZoneType } from "../../domain/layouts/layoutZone";
import { Block } from "../../domain/blocks/block";
import { TenantSettingsRepository } from "../../domain/tenant-settings-repository";
import { CalendarUIService } from "../../domain/calendar-ui-service";
import { BroadcastPreset } from "../../domain/broadcasts/broadcast-preset";
import { Switcher } from "../../domain/broadcasts/switcher";
import {
  EChannelBroadcastMode,
  IChannelBroadcastModeChecker,
} from "../../domain/broadcasts/i-channel-broadcast-mode-checker";

@Component({
  selector: "icn-calendar-list",
  templateUrl: "./calendar-list.component.html",
  styleUrls: ["./calendar-list.component.scss"],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarListComponent
  implements OnInit, OnChanges, OnDestroy, AfterViewChecked
{
  @ViewChild(ContextMenuComponent) public basicMenu;
  @ViewChildren("empty") emptySections;
  @ViewChild("listviewScrollableContainer", { static: true })
  private _scrollableContainer: ElementRef;
  @ViewChildren("showElement") showElements;
  @ViewChildren("newSecEventDragAreaElement") newSecEventDragAreaElement;
  @ViewChildren("videoSectionElement") videoSectionElement;

  @Input() currentView: CalendarView;
  @Input() refreshOnNow: boolean;

  @Input()
  showCurrentTimeIndicator = true;

  @Input() isBlock: boolean;
  @Input()
  futurePreviewViewModel: FuturePreviewViewModel;
  @Input() fromSecEventsPopup;

  @Output() refreshOnNowChange = new EventEmitter<any>();
  @Output() currentDateChange = new EventEmitter();

  hoverShowIndex = undefined;
  preventBlurEvent = false;
  emptyDragIndex = -2;
  canMediaDropCapsul = false;
  lastEmptyEntry = false;
  outsideDivEntry = false;
  isLoading = false;
  _isSecEventsLoading = false;
  showsChangedSubscription: Subscription;
  changeCurrentDateUpdated: Subscription;
  searchResultHighlightedUpdated: Subscription;
  feedDefaultDuration = moment.duration(60, "minutes");
  broadcastPresetShowDefaultDuration = moment.duration(60, "minutes");
  editMode = false;
  duringDrag = false;
  tenantSettings: TenantSettings;
  secEventType = SecEventType;
  isHoveringOnShow = false;
  lastGetShowsSubject: Subject<void>;
  scheduleUpdateListenerHandler: any;
  public _currentChannel: Channel;

  private gridColumnsChangedSubscription: Subscription;
  public gridColumns;
  cacheUpdatedSubscription: Subscription;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private ui: UI,
    private userService: UserService,
    private router: Router,
    private showApi: ShowRepository,
    private tenantSettingsService: TenantSettingsRepository,
    private socketService: Socket,
    private ngxSmartModalService: NgxSmartModalService,
    private mediaRepository: MediaRepository,
    private calendarService: CalendarService,
    private showRepository: ShowRepository,
    private calendarSearchService: CalendarSearchService,
    private secEventsService: SecEventsService,
    private calendarUIService: CalendarUIService,
    public copyShowsViewModel: CopyShowsViewModel,
    private _channelBroadcastModeChecker: IChannelBroadcastModeChecker,
  ) {}

  private _shows: Show[] = [];
  filteredShows;
  secEventTypesToFilter: SecEventType[] = [];
  channelFramerate: number;
  channelTimezone: string;

  @Input()
  currentTime: moment.Moment;
  interval;
  mediaUpdatedSubscription: Subscription;
  mediaPackshotUploadFinishedSubscription: Subscription;
  resultUpdateRef: Subscription;

  numShowsExpanded = 0;

  private alertIfChangingCurrentlyPlayingItemMiddleware = (
    startTime: moment.Moment,
    next,
    media: MediaInfo = null,
  ) => {
    return new Promise((resolve, reject) => {
      if (media) {
        if (
          (media.licenseFrom &&
            startTime.isBefore(media.licenseFrom.startOf("day"))) ||
          (media.licenseTo && startTime.isAfter(media.licenseTo.endOf("day")))
        ) {
          this.ui.globalNotify(this.ui.EVENTS.LicensingIssue, null, null);
          this.isLoading = false;
          this.changeDetectorRef.markForCheck();
          return resolve(false);
        }
      }
      if (this.isBlock == false && startTime.isSameOrBefore(moment())) {
        this.ui.globalNotify(
          this.ui.EVENTS.ChangePlayingItem,
          () => {
            next().then(resolve).catch(reject);
          },
          null,
        );
      } else {
        next().then(resolve).catch(reject);
      }
    });
  };

  get shows() {
    return this._shows;
  }

  set shows(newShows: Show[]) {
    newShows.forEach((show, index) => {
      show.order = index;
    });
    this._shows = newShows;
  }

  ngOnInit() {
    if (this.showCurrentTimeIndicator) {
      this.interval = setInterval(() => {
        this.currentTime = moment();
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
      }, 1000);
    }

    this.userService.getCurrentChannel().then((channel) => {
      if (channel) {
        this._currentChannel = channel;
        this.channelFramerate = channel.framerate;
        this.channelTimezone = this.userService.getTimezoneValueById(
          channel.timezoneId,
        );
        this.scheduleUpdateListenerHandler =
          this._onSchedulerUpdatedEventHanlderCalendar.bind(this);
        const schedulerUpdatesSubscription = async () =>
          this.socketService.startListeningForSchedulerUpdates(
            channel.id,
            this.scheduleUpdateListenerHandler,
          );
        this.socketService.onHubReconnected.subscribe(async () => {
          this.socketService.stopListeningForSchedulerUpdates(
            this.scheduleUpdateListenerHandler,
          );
          await schedulerUpdatesSubscription();
          this.refreshView();
        });
        return schedulerUpdatesSubscription();
      }
    });

    this.tenantSettingsService.getTenantSettings().then((settings) => {
      this.tenantSettings = settings;
    });
    console.log("calendar-list->subscribing onShowsChange");
    this.showsChangedSubscription = this.showApi.onShowsChange.subscribe(
      async () => {
        await this.refreshView();
      },
    );

    this.mediaUpdatedSubscription = this.mediaRepository.mediaUpdated.subscribe(
      () => {
        this.refreshView();
      },
    );

    this.mediaPackshotUploadFinishedSubscription =
      this.socketService.packshotUploadFinishedChange.subscribe(() => {
        this.refreshView();
      });
    this.changeCurrentDateUpdated =
      this.calendarService.changeCurrentDate.subscribe((date) => {
        this.validateCurrentViewAndHiglightedItemMatch(date);
      });
    this.searchResultHighlightedUpdated =
      this.calendarSearchService.highlightUpdate.subscribe(
        this.onsearchResultHighlightedUpdated.bind(this),
      );
    this.gridColumnsChangedSubscription =
      this.calendarUIService.ViewColumns.subscribe((columns) => {
        this.gridColumns = columns;
      });
  }

  ngAfterViewChecked() {
    this.showElements._results.forEach(
      (element, index) =>
        (element.nativeElement.ondragover = (event: DragEvent) => {
          if (
            event.dataTransfer.types.includes("text/media") ||
            event.dataTransfer.types.includes("text/graphics") ||
            event.dataTransfer.types.includes("text/markers")
          ) {
            event.preventDefault();
          }
        }),
    );

    this.videoSectionElement._results.forEach(
      (element, index) =>
        (element.nativeElement.ondragover = (event: DragEvent) => {
          this.onDragOver(event, index);
        }),
    );
  }
  toggleSecEvent(show: Show, eventId: string): void {
    console.log("toggleSecEvent->show", show, eventId);
    if (show.secEvents && show.secEvents.length > 0) {
      const secEventsById = Object.assign(
        {},
        ...show.secEvents.map((x) => ({ [x.id]: x })),
      );
      const relevantSecEvent = secEventsById[eventId];
      relevantSecEvent.properties.enabled =
        !relevantSecEvent.properties.enabled;
      const disabledSecEventIds = show.secEvents
        .filter((se) => !se.properties.enabled)
        .map((se) => se.id);

      this.showApi
        .updateShowDisabledSecEvents(show.id, disabledSecEventIds, false)
        .then(() => {
          console.log(
            "CalendarListComponent->toggleSecEvent->Finished",
            eventId,
          );
        })
        .catch((err) => {
          relevantSecEvent.properties.enabled =
            !relevantSecEvent.properties.enabled;
          if (err) {
            this.ui.notify(this.ui.EVENTS.ShowAlert, {
              title: "Failed To Toggle Secondary Event",
              message: "Failed To Toggle Secondary Event.",
            });
          }
        });
    }
  }

  foundInSearchResults(showId: string) {
    return showId === this.calendarSearchService.currentItem;
  }

  closeGap(show: Show) {
    this.alertIfChangingCurrentlyPlayingItemMiddleware(show.startTime, () => {
      return this.showApi.closeGapAfter(show).catch((err) => {
        if (err) {
          this.ui.notify(this.ui.EVENTS.ShowAlert, {
            title: "Close Gap",
            message: "Can't move more than a week of shows.",
          });
        }
      });
    });
  }

  isLongMedia(index) {
    return (
      this.shows[index]?.duration.asSeconds() >=
      this.tenantSettings.LongShowSeconds
    );
  }

  shouldShowIndicatorLine(show) {
    if (!show) {
      return false;
    }
    const prevShow = this.shows[show.order - 1];
    if (!prevShow) {
      return false;
    }
    if (show.order > 0 && prevShow?.["expanded"] === true) {
      return false;
    } else if (
      show.order > 0 &&
      prevShow.startTime <= this.currentTime &&
      show.startTime > this.currentTime
    ) {
      return true;
    } else if (show.order === 0 && show.startTime > this.currentTime) {
      return true;
    }
  }

  currentMediaLineIndicatorOffsetTop() {
    let emptyRows = 0;
    if (this.hasEmptyAtBegin()) {
      emptyRows++;
    }
    for (let i = 0; i < this.shows.length; i++) {
      if (this.isAtTime(i, false)) {
        return 60 * (i + emptyRows) - 5;
      }
      if (this.hasEmptyBetweenMovies(i)) {
        emptyRows++;
      }
    }
    return 0;
  }

  calculateHowManyEmpties(list) {
    let result = 0;
    for (let i = 0; i < list.length; i++) {
      if (this.hasEmptyBetweenMovies(i)) {
        result++;
      }
    }
    return result;
  }

  scrollToCurrentTime() {
    const listBeforeNow = this.shows.filter((x) =>
      x.endTime.isSameOrBefore(this.currentView.currentDate),
    );
    this.scrollToShow(listBeforeNow);
  }
  scrollToShow(shows: Show[]) {
    const emptyAtBegin = this.hasEmptyAtBegin() ? 1 : 0;
    const numberOfItemsBefore = shows.length;
    const numberOfEmptyBetweenMovies = this.calculateHowManyEmpties(shows);
    this._scrollableContainer.nativeElement.scrollTop = Math.floor(
      (emptyAtBegin + numberOfEmptyBetweenMovies + numberOfItemsBefore) * 60,
    );
    this.refreshOnNow = false;
    this.refreshOnNowChange.emit(this.refreshOnNow);
  }
  private _onSchedulerUpdatedEventHanlderCalendar(
    channelId: number,
    startTimeUtc: Date,
    endTimeUtc: Date,
  ) {
    console.log(
      "_onSchedulerUpdatedEventHanlderCalendar",
      channelId,
      startTimeUtc,
      endTimeUtc,
    );
    if (channelId === this._currentChannel.id) {
      this.calendarService.clearCache(false);
      this.refreshView().then();
      //this.showApi.onShowsChange.next();
    }
  }

  async refreshView(moveToNowPlayingShowAfterShowsLoaded = false) {
    this.isLoading = true;
    this._isSecEventsLoading = true;
    this.changeDetectorRef.markForCheck();

    const from = this.currentView.fromDate().clone();
    const to = this.currentView.toDate().clone();
    if (this.lastGetShowsSubject && !this.lastGetShowsSubject.closed) {
      console.log(
        "calendar-list-component->canceling previous get shows request",
      );
      try {
        this.lastGetShowsSubject.next();
        this.lastGetShowsSubject.complete();
      } catch (err) {
        console.error(
          "calendar-list-component->refreshView->error",
          err,
          this.lastGetShowsSubject,
        );
      }
    }

    this.lastGetShowsSubject = new Subject<void>();

    this._currentChannel = await this.userService.getCurrentChannel();
    console.log(
      "calendar-list-component-> this.calendarService.getByDates for channel ",
      this._currentChannel.id,
    );
    const shows = await this.calendarService.getByDates(
      this._currentChannel.id,
      from,
      to,
      false,
      this.lastGetShowsSubject,
    );
    if (!shows) {
      this.isLoading = false;
      this._isSecEventsLoading = false;
      return;
    }
    // handle expanded property
    const expendedByShowId = this.shows.reduce(
      (a, x) => ({ ...a, [x.id]: x }),
      {},
    );
    this.shows = shows;
    this.isLoading = false;
    this.changeDetectorRef.markForCheck();

    const searchResultHighlighted = this.calendarSearchService.currentItem;
    if (searchResultHighlighted) {
      const show = this.shows.find((s) => s.id === searchResultHighlighted);
      if (show) {
        const listBeforeNow = this.shows.filter((x) =>
          x.endTime.isSameOrBefore(show.startTime),
        );
        this.scrollToShow(listBeforeNow);
      }
    }
    if (moveToNowPlayingShowAfterShowsLoaded) {
      setTimeout(() => this.scrollToCurrentTime(), 0);
    }

    this.changeDetectorRef.markForCheck();
    const showsWithSecEvents = await this.calendarService.getByDates(
      this._currentChannel.id,
      from,
      to,
      true,
      this.lastGetShowsSubject,
    );
    //await this.calendarService.updateShows();
    if (!showsWithSecEvents) {
      this.isLoading = false;
      this._isSecEventsLoading = false;
      return;
    }
    this._isSecEventsLoading = false;

    this.shows = showsWithSecEvents.map((s) => {
      if (expendedByShowId[s.id] && expendedByShowId[s.id].expanded) {
        // @ts-ignore
        s.expanded = expendedByShowId[s.id].expanded ?? false;
      }
      return s;
    });
    console.log("refreshView->this.shows", this.shows);
    this.calendarService.clearCache(this._currentChannel.isBlock);
    this.changeDetectorRef.markForCheck();

    /*if (from.isSame(moment(), 'day')) {
          await this.calendarService.update24HoursShowsCache(this.shows);

        }*/
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["currentView"]) {
      const previousView = changes["currentView"].previousValue;
      const currentView = changes["currentView"].currentValue;

      if (
        !previousView ||
        currentView.fromDate()._i !== previousView.fromDate()._i
      ) {
        console.log("calendar-list: previousView", previousView);
        this.refreshView(true).then(() => {
          this.expandAndScrollToShow();
        });
      }
    }
    if (changes["refreshOnNow"] && changes["refreshOnNow"].currentValue) {
      this.scrollToCurrentTime();
    }
  }

  getSubtitles(item) {
    if (item.subtitles) {
      return item.subtitles.length === 1
        ? item.subtitles[0].language.toUpperCase()
        : item.subtitles.length;
    } else {
      return 0;
    }
  }

  hasEmptyAtBegin(): boolean {
    if (this.shows.length === 0) {
      return true;
    }
    const firstVideo = this.shows[0];
    return firstVideo.startTime.isAfter(this.currentView.fromDate());
  }

  hasEmptyBetweenMovies(index): boolean {
    if (this.shows.length === index + 1) {
      return this.shows[index].endTime.isBefore(
        this.currentView.fromDate().clone().endOf("day"),
      );
    }
    const nextShow = this.shows[index + 1];
    const currentShow = this.shows[index];
    const gapBetweenShows = nextShow?.startTime.diff(currentShow.endTime);

    let possibleGapInMs = 40;
    if (this.channelFramerate) {
      possibleGapInMs = 1000 / this.channelFramerate;
    }
    return gapBetweenShows >= possibleGapInMs;
  }

  calculateEmptyDuration(itemIndex): moment.Moment {
    if (itemIndex === -1) {
      if (this.shows.length === 0) {
        return this.currentView
          .fromDate()
          .clone()
          .hour(23)
          .minute(59)
          .second(59)
          .millisecond(999);
      } else {
        return moment(this.shows[0].startTime.clone().valueOf());
      }
    }
    const diffTime = moment(this.shows[itemIndex].endTime.valueOf());
    if (itemIndex + 1 === this.shows.length) {
      const currentShow = diffTime.clone();
      const diff = currentShow.endOf("day").diff(diffTime);
      return currentShow.startOf("day").add(diff, "ms");
    } else {
      const currentShow = moment(this.shows[itemIndex + 1].startTime.valueOf());
      const diff = currentShow.diff(diffTime);
      return currentShow.startOf("day").add(diff, "ms");
    }
  }

  calculateEmptyEndTime(itemIndex): string {
    let time;
    if (itemIndex === -1) {
      if (this.shows.length === 0) {
        time = this.currentView
          .fromDate()
          .clone()
          .hour(23)
          .minute(59)
          .second(59)
          .millisecond(999);
      } else {
        time = this.shows[0].startTime;
      }
    } else {
      if (itemIndex + 1 === this.shows.length) {
        time = this.currentView
          .fromDate()
          .clone()
          .hour(23)
          .minute(59)
          .second(59)
          .millisecond(999);
      } else {
        time = this.shows[itemIndex + 1].startTime;
      }
    }

    if (this.channelFramerate) {
      return this.formatTime(time);
    }
    return moment(time.valueOf()).format("HH:mm:ss.SSS");
  }

  async onDrop(event: DragEvent, itemBeforeEmpty, element, isEmpty = true) {
    this.duringDrag = false;
    this.emptyDragIndex = -2;
    this.hoverShowIndex = undefined;
    const draggedMedia: MediaItem = event.dataTransfer.getData("text/media")
      ? JSON.parse(event.dataTransfer.getData("text/media"))
      : undefined;
    const draggedShow: Show = event.dataTransfer.getData("text/show")
      ? JSON.parse(event.dataTransfer.getData("text/show"))
      : undefined;
    const draggedFeed: LiveFeedInfo = event.dataTransfer.getData("text/feed")
      ? JSON.parse(event.dataTransfer.getData("text/feed"))
      : undefined;
    const draggedDynamicPromo: DynamicPromoInfo = event.dataTransfer.getData(
      "text/promo",
    )
      ? JSON.parse(event.dataTransfer.getData("text/promo"))
      : undefined;

    const draggedLayout: Layout = event.dataTransfer.getData("text/layout")
      ? JSON.parse(event.dataTransfer.getData("text/layout"))
      : undefined;

    const draggedBlock: Block = event.dataTransfer.getData("text/block")
      ? JSON.parse(event.dataTransfer.getData("text/block"))
      : undefined;

    // const draggedGraphicsItem = event.dataTransfer.getData("text/graphics")
    //   ? JSON.parse(event.dataTransfer.getData("text/graphics"))
    //   : undefined;

    let draggedBroadcastPreset: BroadcastPreset = event.dataTransfer.getData(
      "text/broadcast",
    )
      ? JSON.parse(event.dataTransfer.getData("text/broadcast"))
      : undefined;

    if (
      !draggedMedia &&
      !draggedShow &&
      !draggedFeed &&
      !draggedLayout &&
      !draggedBlock &&
      //!draggedGraphicsItem &&
      !draggedBroadcastPreset
    ) {
      return;
    }
    if (this.isBlock && draggedBroadcastPreset) {
      this.ui.notify(this.ui.EVENTS.ShowAlert, {
        title: "Error",
        message: "Broadcast presets can't be scheduled in a block!",
      });
      return;
    }
    // if (
    //   !this.isBlock ||
    //   (draggedGraphicsItem != undefined &&
    //     this._currentChannel.isBlockStack == false)
    // ) {
    //   return;
    // }
    if (
      this._currentChannel &&
      !this._currentChannel.isBlockStack &&
      draggedBlock?.isBlockStack &&
      !this.isBlock
    ) {
      this.ui.notify(this.ui.EVENTS.ShowAlert, {
        title: "Error",
        message: "Stacks can't be scheduled!",
      });
      return;
    }

    let startTime: moment.Moment;
    if (isEmpty) {
      startTime = itemBeforeEmpty
        ? itemBeforeEmpty.endTime
        : this.currentView.fromDate().clone();
    } else {
      startTime = itemBeforeEmpty.startTime;
    }
    let promise;

    if (!!draggedMedia) {
      promise = async () => {
        const media = await this.mediaRepository.getMediaInfo(draggedMedia.id);
        if (
          this.isBlock &&
          media.mediaLinkedType &&
          media.mediaLinkedType === 3
        ) {
          //it's a contract
          this.ui.notify(this.ui.EVENTS.ShowAlert, {
            title: "Contract Failed",
            message: "Contract can't be placed inside the block!",
          });
          this.isLoading = false;
          this.changeDetectorRef.markForCheck();
        } else {
          if (media.segments && media.segments.length > 0) {
            return await this.alertIfChangingCurrentlyPlayingItemMiddleware(
              startTime,
              async () => {
                return await this.mediaItemWithSegmentsDraggedEventHandler(
                  startTime,
                  media,
                );
              },
              media,
            );
          } else {
            return await this.alertIfChangingCurrentlyPlayingItemMiddleware(
              startTime,
              async () => {
                return await this.showApi.createMediaShow(
                  draggedMedia.id,
                  startTime,
                );
              },
              media,
            );
          }
        }
      };
    } else if (!!draggedFeed) {
      promise = async () => {
        return await this.alertIfChangingCurrentlyPlayingItemMiddleware(
          startTime,
          async () => {
            return await this.showApi.createLiveShow(
              draggedFeed.id,
              startTime,
              this.feedDefaultDuration,
            );
          },
        );
      };
    } else if (!!draggedBroadcastPreset) {
      draggedBroadcastPreset = new BroadcastPreset(
        draggedBroadcastPreset.id,
        draggedBroadcastPreset.name,
        draggedBroadcastPreset.thumbnailUrl,
        draggedBroadcastPreset.switchers.map(
          (p) => new Switcher(p.name, p.items),
        ),
        [...draggedBroadcastPreset.audioChannels],
      );
      if (
        !draggedBroadcastPreset.hasPreviewSelected ||
        !draggedBroadcastPreset.hasProgramSelected
      ) {
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Error",
          message:
            "Both the program and preview windows of a broadcast must be filled before it can be scheduled!",
        });
        this.isLoading = false;
        return Promise.resolve();
      }

      promise = async () => {
        return this.alertIfChangingCurrentlyPlayingItemMiddleware(
          startTime,
          async () => {
            return await this.showRepository.createBroadcastPresetShow(
              draggedBroadcastPreset.id,
              startTime,
              this.broadcastPresetShowDefaultDuration.asMilliseconds(),
            );
          },
        );
      };
    } else if (!!draggedLayout) {
      promise = async () => {
        let durationMs = this.feedDefaultDuration.asMilliseconds();
        const baseZone = draggedLayout.zones[0];
        if (!!baseZone.durationMs) {
          durationMs = baseZone.durationMs;
        } else if (baseZone.zoneType === ELayoutZoneType.media) {
          const baseZoneMedia = await this.mediaRepository.getMediaInfo(
            baseZone.mediaId,
          );
          durationMs = baseZoneMedia.contentDuration.asMilliseconds();
        }
        return await this.alertIfChangingCurrentlyPlayingItemMiddleware(
          startTime,
          async () => {
            return await this.showApi.createLayoutShow(
              draggedLayout.id,
              startTime,
              durationMs,
            );
          },
        );
      };
    } else if (!!draggedBlock) {
      promise = async () => {
        const fromDate = moment().utc().subtract(100, "years");
        const toDate = moment().utc().add(100, "years");
        const foundShows = await this.showApi.getByDates(
          draggedBlock.id,
          fromDate,
          toDate,
          true,
          this.lastGetShowsSubject,
          true,
        );
        return await this.alertIfChangingCurrentlyPlayingItemMiddleware(
          startTime,
          async () => {
            return await CopyShowsViewModel.showConfirmSecondaryEventSignalSettingsPopup(
              this.ui,
              this.showRepository,
              this._currentChannel,
              this.isBlock,
              foundShows[0],
              foundShows.pop(),
              startTime,
            );
          },
        );
      };
    }
    //  else if (!!draggedGraphicsItem) {
    //   promise = async () => {
    //     return await this.showApi.createGraphicsShow(
    //       draggedGraphicsItem.id,
    //       draggedGraphicsItem.uid,
    //       startTime,
    //     );
    //   };
    // }
    else {
      var media: MediaInfo = null;
      if (draggedShow && (draggedShow as any).mediaId) {
        media = await this.mediaRepository.getMediaInfo(
          (draggedShow as any).mediaId,
        );
      }
      promise = async () => {
        return await this.alertIfChangingCurrentlyPlayingItemMiddleware(
          startTime,
          async () => {
            return await this.showApi.updateShowTime(draggedShow.id, startTime);
          },
          media,
        );
      };
    }
    this.isLoading = true;
    try {
      await promise();
    } catch (err) {
      if (err.status === 404) {
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Reorder Show",
          message: "Media or channel not found",
        });
      } else if (err.status === 400) {
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Reorder Show",
          message: "Bad request",
        });
      } else if (err.status === 500) {
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Reorder Show",
          message: "Can't move more than a week of shows.",
        });
      }
    } finally {
      this.onEmptyDragLeave(element, -2);
      this.isLoading = false;
    }
  }

  emptySlotText(index: number, _isBetweenShows?: boolean): string {
    if (index === -1) {
      if (this.shows.length === 0) {
        return "Empty - Drag to fill";
      } else {
        const endTime = this.shows[0].startTime;
        const currentCalendarTime = this.currentView.fromDate().clone();
        currentCalendarTime.hour(moment().hour());
        currentCalendarTime.minute(moment().minute());
        currentCalendarTime.second(moment().second());
        if (endTime.isBefore(currentCalendarTime)) {
          return "Empty";
        }
        return "Empty - Drag to fill";
      }
    } else {
      if (this.shows.length === index + 1) {
        return "Empty - Drag to fill";
      } else {
        const endTime = this.shows[index + 1].startTime;
        const currentCalendarTime = this.currentView.fromDate().clone();
        currentCalendarTime.hour(moment().hour());
        currentCalendarTime.minute(moment().minute());
        currentCalendarTime.second(moment().second());
        if (endTime.isBefore(currentCalendarTime)) {
          return "Empty";
        }
        return "Empty - Drag to fill";
      }
    }
  }

  removeShow(show: Show) {
    let call = () => {};
    let selectedShows = this.shows.filter((x) => (x as any).selected);

    if (selectedShows && selectedShows.length > 0) {
      call = () => {
        this.showApi.deleteShows(selectedShows.map((x) => x.id));
      };
    } else {
      call = () => {
        this.showApi.deleteShow(show.id);
      };
      selectedShows = [show];
    }
    if (selectedShows.some((x) => this.isAtTime(x.order, false))) {
      this.ui.globalNotify(this.ui.EVENTS.ChangePlayingItem, call, null);
    } else {
      call();
    }
  }

  formatTime(time: moment.Moment): string {
    if (this.channelFramerate) {
      const fpsTime = this.padFps(
        ConversionUtils.getFpsFromMs(
          time.milliseconds(),
          this.channelFramerate,
        ),
      );
      return moment(time.valueOf()).format("HH:mm:ss") + fpsTime;
    }
    return moment(time.valueOf()).format("HH:mm:ss.SSS");
  }
  formatTextTime(time: string): string {
    if (!time) {
      return "";
    }
    var timeAsMoment = moment().utc();
    var splitTimeMS = time.split(".");
    var splitTime = time.split(/:/);
    timeAsMoment
      .hours(parseInt(splitTime[0]))
      .minutes(parseInt(splitTime[1]))
      .seconds(splitTime[2] ? parseInt(splitTime[2]) : 0)
      .milliseconds(splitTimeMS[1] ? parseInt(splitTimeMS[1].slice(0, 3)) : 0);
    return timeAsMoment.format("HH:mm:ss.SSS");
  }

  formatTimeFpsMs(time: moment.Moment): string {
    const msTime =
      1 /
      ConversionUtils.getFpsFromMs(
        1 / time.milliseconds(),
        this.channelFramerate,
      );
    return moment(time.valueOf()).format("HH:mm:ss") + msTime;
  }

  formatName(item: Show) {
    return this.calendarSearchService.highlightTerm(item.name, item.id);
  }

  formatDuration(
    duration: moment.Duration,
    additionalMs = 0,
    doLog: boolean = false,
  ): string {
    const calculatedDuration = moment.duration(
      duration.asMilliseconds() + additionalMs,
      "milliseconds",
    );
    if (!this.channelFramerate) {
      return moment
        .utc(calculatedDuration.asMilliseconds())
        .format("HH:mm:ss.SSS");
    }
    const rowFps = ConversionUtils.getFpsFromMs(
      calculatedDuration.milliseconds(),
      this.channelFramerate,
    );
    const fps = this.padFps(rowFps);
    if (doLog) {
      console.log(
        "calendar-list->duration->",
        rowFps,
        fps,
        this.channelFramerate,
        calculatedDuration.milliseconds(),
      );
    }
    return (
      moment.utc(calculatedDuration.asMilliseconds()).format("HH:mm:ss") + fps
    );
  }

  onContentEditableClick(event: MouseEvent, item: Show, element: HTMLElement) {
    if (item && item.isAnchored) {
      return;
    }
    if (
      item instanceof BroadcastPresetShow &&
      item.startTime.isBefore(moment().utc()) &&
      item.endTime.isAfter(moment().utc())
    ) {
      return;
    }
    var call = () => {
      if (element) {
        event.stopPropagation();
        element.setAttribute("contenteditable", "true");
        element.focus();
        this.editMode = true;
        console.log("calendar-list->onContentEditableClick->element", element);
        element["_lastInnerText"] = element.innerText;
      }
    };
    if (this.isAtTime(item.order, false)) {
      this.ui.globalNotify(this.ui.EVENTS.ChangePlayingItem, call, null);
    } else {
      call();
    }
  }

  onStartTimeKeypress(event, media, startTime) {
    if (event.keyCode !== 13) {
      return;
    }
    this.editStartTimeExit(event, media, startTime);
    return false;
  }

  editCommentExit(event, show: Show) {
    event.target.scrollTop = 0;
    event.target.style.height = "18px";
    if (!event.target.innerText && !show.comment) {
      return;
    }
    if (event.target.innerText != show.comment) {
      this.showApi.updateShowComment(show.id, event.target.innerText);
    }
  }

  async editStartTimeExit(event, show: Show, startTimeElement: HTMLElement) {
    if (this.preventBlurEvent) {
      this.preventBlurEvent = false;
      return;
    }
    this.disableContentEditable(startTimeElement);
    if (this._checkIfElementUpdate(startTimeElement)) {
      const match = this.testTimePattern(event.target.innerText);
      if (this.channelFramerate && Number(match[4]) > this.channelFramerate) {
        const msg = `Frame should be in the ${this.channelFramerate}FPS range`;
        this.testTimePatternFailed(
          startTimeElement,
          show.startTime,
          "Update Show start time",
          msg,
        );
        return;
      }
      const newTime = this.checkAndSetNewTimeFormat(match);

      if (!newTime) {
        this.testTimePatternFailed(
          startTimeElement,
          show.startTime,
          "Update Show Start Time",
        );
      } else {
        if (this.checkIfTimeIsTheSame(show.startTime, newTime)) {
          this.preventBlurEvent = false;
          return;
        }
        if (
          show.startTime.hour() == newTime.hour() &&
          show.startTime.minutes() == newTime.minutes() &&
          show.startTime.seconds() == newTime.second() &&
          show.startTime.milliseconds() == newTime.milliseconds() &&
          show.startTime
            .clone()
            .add(show.duration.asMilliseconds(), "milliseconds")
            .dayOfYear() == newTime.dayOfYear()
        ) {
          // show spans across midnight but it's same time
          this.preventBlurEvent = false;
          return;
        }

        if (show && (show as any).mediaId) {
          const media = await this.mediaRepository.getMediaInfo(
            (show as any).mediaId,
          );
          if (
            (media &&
              media.licenseFrom &&
              newTime.isBefore(media.licenseFrom.startOf("day"))) ||
            (media.licenseTo && newTime.isAfter(media.licenseTo.endOf("day")))
          ) {
            this.ui.globalNotify(this.ui.EVENTS.LicensingIssue, null, null);
            this.preventBlurEvent = false;
            startTimeElement.innerHTML = this.formatTime(show.startTime);
            return;
          }
        }
        this.showApi.updateShowTime(show.id, newTime).then(() => {
          this.preventBlurEvent = false;
        });
      }
    }
  }
  isLive(show: Show) {
    return show instanceof LiveShow;
  }
  isLayoutShow(show: Show) {
    return show instanceof LayoutShow;
  }
  isBroadcastShow(show: Show) {
    return show instanceof BroadcastPresetShow;
  }
  isContract(show: Show) {
    if (show instanceof MediaShow) {
      const mediaShow = <MediaShow>show;
      return mediaShow.isContract;
    }
    return false;
  }

  onEndTimeKeypress(event, show, endTime) {
    if (event.keyCode !== 13) {
      return;
    }
    this.editEndTimeExit(event, show, endTime);
    return false;
  }

  editEndTimeExit(event, show: Show, endTimeElement: HTMLSpanElement) {
    if (this.preventBlurEvent) {
      this.preventBlurEvent = false;
      return;
    }
    this.disableContentEditable(endTimeElement);
    if (this._checkIfElementUpdate(endTimeElement)) {
      const match = this.testTimePattern(event.target.innerText);
      if (this.channelFramerate && Number(match[4]) > this.channelFramerate) {
        const msg = `Frame should be in the ${this.channelFramerate}FPS range`;
        this.testTimePatternFailed(
          endTimeElement,
          show.endTime,
          "Update Show end time",
          msg,
        );
        return;
      }
      const newTime = this.checkAndSetNewTimeFormat(match);
      if (this.checkIfTimeIsTheSame(show.endTime, newTime)) {
        this.preventBlurEvent = false;
        return;
      }
      if (!newTime) {
        this.testTimePatternFailed(
          endTimeElement,
          show.endTime,
          "Update Show End Time",
        );
      } else {
        this.showApi
          .updateShowDuration(show.id, moment(newTime.diff(show.startTime)))
          .then(() => {
            this.preventBlurEvent = false;
          });
      }
    }
  }

  onDurationKeypress(event, show, duration) {
    if (event.keyCode !== 13) {
      return;
    }
    this.editDurationExit(event, show, duration);
    return false;
  }

  editDurationExit(event, show: Show, durationElement: HTMLElement) {
    if (this.preventBlurEvent) {
      this.preventBlurEvent = false;
      return;
    }
    this.disableContentEditable(durationElement);
    if (this._checkIfElementUpdate(durationElement)) {
      const newDuration = this.testTimePattern(event.target.innerText);
      if (!newDuration) {
        this.testTimePatternFailed(
          durationElement,
          show.duration,
          "Update Show Duration",
        );
      } else {
        if (
          this.channelFramerate &&
          Number(newDuration[4]) > this.channelFramerate
        ) {
          const msg = `Frame should be in the ${this.channelFramerate}FPS range.`;
          this.testTimePatternFailed(
            durationElement,
            show.duration,
            "Update Show Duration",
            msg,
          );
        } else {
          const durationToUpdate =
            this.convertTimeRegexMatchToDuration(newDuration);
          if (this.checkIfTimeIsTheSame(show.duration, durationToUpdate)) {
            this.preventBlurEvent = false;
            return;
          }
          this.showApi
            .updateShowDuration(show.id, durationToUpdate.asMilliseconds())
            .then(() => (this.preventBlurEvent = false))
            .catch((err) => {
              if (err.status === 400) {
                this.ui.notify(this.ui.EVENTS.ShowAlert, {
                  title: "Update show duation",
                  message: "Bad request",
                });
              } else if (err.status === 500) {
                this.ui.notify(this.ui.EVENTS.ShowAlert, {
                  title: "Update show duation",
                  message: "Can't move more than a week of shows.",
                });
              }
              durationElement.innerText = this.formatDuration(show.duration);
            });
        }
      }
    }
  }

  onSomKeypress(event, show, elment) {
    if (event.keyCode !== 13) {
      return;
    }
    this.editSomExit(event, show, elment);
    return false;
  }

  editSomExit(event: FocusEvent, show: Show, som: HTMLElement): void {
    if (this.preventBlurEvent) {
      this.preventBlurEvent = false;
      return;
    }
    this.disableContentEditable(som);
    const newDuration = this.testTimePattern(
      (event.target as HTMLElement).innerText,
    );
    const fieldName = "SOM";
    if (!newDuration) {
      this.testTimePatternFailed(som, show.som, `Update Show ${fieldName}`);
    } else {
      if (
        this.channelFramerate &&
        Number(newDuration[4]) > this.channelFramerate
      ) {
        const msg = `Frame should be in the ${this.channelFramerate}FPS range`;
        this.testTimePatternFailed(
          som,
          show.som,
          `Update Show ${fieldName}`,
          msg,
        );
      } else {
        const somDuration = this.convertTimeRegexMatchToDuration(newDuration);

        if (this.checkIfTimeIsTheSame(show.som, somDuration)) {
          this.preventBlurEvent = false;
          return;
        } else if (
          show.mediaDuration.asMilliseconds() < somDuration.asMilliseconds()
        ) {
          const msg = `SOM cannot be longer than the Media Duration (${this.formatDuration(show.mediaDuration)})`;
          this.testTimePatternFailed(som, show.som, "Update Show SOM", msg);
        } else {
          this.showApi
            .updateShowSom(show.id, somDuration.asMilliseconds())
            .then(() => (this.preventBlurEvent = false))
            .catch((err) => {
              if (err.status === 400) {
                this.ui.notify(this.ui.EVENTS.ShowAlert, {
                  title: `Update show ${fieldName}`,
                  message: "Bad request",
                });
              } else if (err.status === 500) {
                this.ui.notify(this.ui.EVENTS.ShowAlert, {
                  title: `Update show ${fieldName}`,
                  message: "Can't move more than a week of shows.",
                });
              }
              som.innerText = this.formatDuration(show.som);
              this.preventBlurEvent = false;
            });
        }
      }
    }
  }

  editVITCExit(event, show: Show, som) {
    if (this.preventBlurEvent) {
      this.preventBlurEvent = false;
      return;
    }
    this.disableContentEditable(som);
    const newDuration = this.testTimePattern(event.target.innerText);
    const fieldName = "VITC-SOM";
    if (!newDuration) {
      this.testTimePatternFailed(som, show.som, `Update Show ${fieldName}`);
    } else {
      if (
        this.channelFramerate &&
        Number(newDuration[4]) > this.channelFramerate
      ) {
        const msg = `Frame should be in the ${this.channelFramerate}FPS range`;
        this.testTimePatternFailed(
          som,
          show.som,
          `Update Show ${fieldName}`,
          msg,
        );
      } else {
        const somDuration = this.convertTimeRegexMatchToDuration(newDuration);
        somDuration.subtract(show.mediaStartTimestampMs);
        if (this.checkIfTimeIsTheSame(show.som, somDuration)) {
          this.preventBlurEvent = false;
          return;
        } else if (somDuration.asMilliseconds() < show.mediaStartTimestampMs) {
          const mediaStartTimestamp = moment.duration(
            show.mediaStartTimestampMs,
            "milliseconds",
          );
          const msg = `SOM cannot be less than the Media Start TimeStamp (${this.formatDuration(mediaStartTimestamp)})`;
          this.testTimePatternFailed(
            som,
            show.som,
            `Update Show ${fieldName}`,
            msg,
          );
        } else if (
          show.mediaDuration.asMilliseconds() <
          somDuration.asMilliseconds() - show.mediaStartTimestampMs
        ) {
          const msg = `SOM cannot be longer than the Media Duration (${this.formatDuration(show.mediaDuration)})`;
          this.testTimePatternFailed(som, show.som, "Update Show SOM", msg);
        } else {
          this.showApi
            .updateShowSom(show.id, somDuration.asMilliseconds())
            .then(() => (this.preventBlurEvent = false))
            .catch((err) => {
              if (err.status === 400) {
                this.ui.notify(this.ui.EVENTS.ShowAlert, {
                  title: `Update show ${fieldName}`,
                  message: "Bad request",
                });
              } else if (err.status === 500) {
                this.ui.notify(this.ui.EVENTS.ShowAlert, {
                  title: `Update show ${fieldName}`,
                  message: "Can't move more than a week of shows.",
                });
              }
              som.innerText = this.formatDuration(show.som);
              this.preventBlurEvent = false;
            });
        }
      }
    }
  }
  checkIfTimeIsTheSame(
    before: moment.Moment | moment.Duration,
    after: moment.Moment | moment.Duration,
  ): boolean {
    if (moment.isMoment(before) && !this.channelFramerate) {
      return before.isSame(after as moment.Moment);
    } else {
      const beforeFrame = ConversionUtils.getFpsFromMs(
        before.milliseconds(),
        this.channelFramerate,
      );
      const afterFrame = ConversionUtils.getFpsFromMs(
        after.milliseconds(),
        this.channelFramerate,
      );
      const newBefore = before.clone().subtract(before.milliseconds());
      const newAfter = after.clone().subtract(after.milliseconds());
      if (moment.isMoment(before)) {
        return (
          (newBefore as moment.Moment).isSame(newAfter as moment.Moment) &&
          beforeFrame === afterFrame
        );
      } else {
        return (
          (newBefore as moment.Duration).asMilliseconds() ===
            (newAfter as moment.Duration).asMilliseconds() &&
          beforeFrame === afterFrame
        );
      }
    }
  }
  disableContentEditable(element: HTMLSpanElement) {
    this.preventBlurEvent = true;
    element.setAttribute("contenteditable", "false");
    this.editMode = false;
  }
  testTimePatternFailed(
    elment: HTMLElement,
    time: moment.Moment | moment.Duration,
    title: string,
    msg?: string,
  ) {
    let message;
    if (msg) {
      message = msg;
    } else {
      message = !this.channelFramerate
        ? "You Must Provide Time Formatted As Follows HH:mm:ss.SSS. (milliseconds)"
        : "You Must Provide Time Formatted As Follows HH:mm:ff. (frames)";
    }
    this.ui.notify(this.ui.EVENTS.ShowAlert, {
      title: title,
      message: message,
    });
    if (time) {
      if (moment.isDuration(time)) {
        elment.innerText = this.formatDuration(time);
      } else {
        elment.innerText = this.formatTime(time);
      }
    }
    this.preventBlurEvent = false;
  }

  checkAndSetNewTimeFormat(match: RegExpMatchArray): moment.Moment {
    const fractionOfASecond = Number(match[4]);
    const ms = this.channelFramerate
      ? ConversionUtils.getMsFromFps(fractionOfASecond, this.channelFramerate)
      : fractionOfASecond;
    return this.currentView
      .fromDate()
      .clone()
      .hour(Number(match[1]))
      .minute(Number(match[2]))
      .second(Number(match[3]))
      .millisecond(ms);
  }

  testTimePattern(time: string): RegExpMatchArray {
    const patternMs =
      /^(0*[0-9]|0*[1][0-9]|0*[2][0-3])\D{1}(0*[0-9]|0*[1-5][0-9])\D{1}(0*[0-9]|0*[1-5][0-9])\D{1}([0-9]{1}|[0-9]{2}|[0-9]{3})$/;
    const patternFs =
      /^(0*[0-9]|0*[1][0-9]|0*[2][0-3])\D{1}(0*[0-9]|0*[1-5][0-9])\D{1}(0*[0-9]|0*[1-5][0-9])\D{1}([0-9]{1}|[0-9]{2})$/;

    const match = time.match(this.channelFramerate ? patternFs : patternMs);
    if (!match) {
      return null;
    }
    return match;
  }
  convertTimeRegexMatchToDuration(match: RegExpMatchArray): moment.Duration {
    const fractionOfASecond = Number(match[4]);
    let ms = this.channelFramerate
      ? ConversionUtils.getMsFromFps(fractionOfASecond, this.channelFramerate)
      : fractionOfASecond;
    if (ms === 1000) {
      ms = 999;
    }
    const stringDuration = `${match[1]}:${match[2]}:${match[3]}.${ms}`;
    return moment.duration({
      milliseconds: ms,
      seconds: Number(match[3]),
      minutes: Number(match[2]),
      hours: Number(match[1]),
    });
  }

  private padFps(fps: number) {
    return fps < 10 ? ".0" + fps : "." + (fps % this.channelFramerate);
  }

  isTimePassed(index, isCheckForEmpty) {
    return (
      this.showCurrentTimeIndicator &&
      this.currentViewTimeComparator(index, isCheckForEmpty, "past") === 1
    );
  }

  isAtTime(index, isCheckForEmpty) {
    return (
      this.showCurrentTimeIndicator &&
      this.currentViewTimeComparator(index, isCheckForEmpty, "present") === 1
    );
  }

  currentViewTimeComparator(index, isCheckForEmpty, pastOrPresent: string) {
    const now = this.currentTime;
    if (pastOrPresent === "past") {
      if (
        this.shows[index]?.startTime
          .clone()
          .add(this.shows[index].duration)
          .isSameOrBefore(now)
      ) {
        return 1;
      }
      return 0;
    } else {
      if (
        this.shows[index]?.startTime.clone().isSameOrBefore(now) &&
        this.shows[index]?.startTime
          .clone()
          .add(this.shows[index].duration)
          .isSameOrAfter(now)
      ) {
        return 1;
      }
      return 0;
    }
  }

  onEmptyDragEnter(element, i) {
    let tempIndex;
    if (i === this.shows.length) {
      tempIndex = i - 1;
      this.outsideDivEntry = true;
    } else if (i === this.shows.length - 1) {
      this.lastEmptyEntry = true;
      tempIndex = i;
    } else {
      tempIndex = i;
    }
    this.duringDrag = true;
    this.emptyDragIndex = tempIndex;
    this.changeDetectorRef.markForCheck();
  }

  onShowDragEnter(index) {
    this.duringDrag = true;
    this.hoverShowIndex = index;
    this.changeDetectorRef.markForCheck();
  }

  onShowDragLeave(index) {
    if (this.hoverShowIndex === index) {
      this.hoverShowIndex = undefined;
    }
    this.changeDetectorRef.markForCheck();
  }

  onEmptyDragLeave(_element: unknown, i: number, _event?: DragEvent): void {
    if (i === this.shows.length && this.lastEmptyEntry) {
      this.outsideDivEntry = false;
      return;
    }
    if (i === this.shows.length - 1 && this.outsideDivEntry) {
      this.lastEmptyEntry = false;
      return;
    }
    this.outsideDivEntry = false;
    this.lastEmptyEntry = false;
    this.emptyDragIndex = -2;
  }

  onDragOver(event: DragEvent, index) {
    const allowedTypes = [
      "text/media",
      "text/show",
      "text/feed",
      "text/layout",
      "text/graphics",
      "text/block",
      "text/broadcast",
    ];
    const { types } = event.dataTransfer;
    const isTypeAllowed = allowedTypes.some((t) => types.includes(t));

    if (isTypeAllowed) {
      event.preventDefault();
    }
  }

  onDragStart(event: DragEvent, index) {
    if (this.isAtTime(index, false) || this.shows[index].isAnchored) {
      return false;
    }
    this.duringDrag = true;
    this.changeDetectorRef.markForCheck();
    event.dataTransfer.setData("text/show", JSON.stringify(this.shows[index]));
  }

  onDynamicScriptClick(item: Show, script) {
    const tz = this.channelTimezone;
    this.userService.getCurrentChannel().then((channel) => {
      window.open(
        script.url +
          `?startTime=${item.startTime.clone().tz(tz).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")}&channelId=${channel.id}`,
      );
    });
  }

  getUserDynamicScripts() {
    return this.userService
      .getCurrentUser()
      .dynamicScripts.filter((x) => x.showScriptOnRightClickWithContent);
  }

  ngOnDestroy() {
    this.shows = [];
    if (this.showsChangedSubscription) {
      this.showsChangedSubscription.unsubscribe();
    }
    if (this.interval) {
      clearInterval(this.interval);
    }

    if (this.mediaPackshotUploadFinishedSubscription) {
      this.mediaPackshotUploadFinishedSubscription.unsubscribe();
    }

    if (this.mediaUpdatedSubscription) {
      this.mediaUpdatedSubscription.unsubscribe();
    }
    if (this.changeCurrentDateUpdated) {
      this.changeCurrentDateUpdated.unsubscribe();
    }
    if (this.searchResultHighlightedUpdated) {
      this.searchResultHighlightedUpdated.unsubscribe();
    }
    if (this.gridColumnsChangedSubscription) {
      this.gridColumnsChangedSubscription.unsubscribe();
    }
    this.socketService.stopListeningForSchedulerUpdates(
      this.scheduleUpdateListenerHandler,
    );
    if (this.cacheUpdatedSubscription) {
      this.cacheUpdatedSubscription.unsubscribe();
    }
  }

  async onClickShow(show: Show) {
    if (this.editMode) {
      return;
    }
    if (show instanceof MediaShow) {
      return this.router.navigate(["/mam/editMedia", show.mediaId], {
        queryParamsHandling: "preserve",
      });
    } else if (show instanceof LiveShow) {
      return this.router.navigate(["/scheduler/live/edit/", show.feedId], {
        queryParamsHandling: "preserve",
      });
    } else if (show instanceof LayoutShow) {
      return this.router.navigate(["/layouts/edit/", show.layoutUid], {
        queryParamsHandling: "preserve",
      });
    } else if (show instanceof BroadcastPresetShow) {
      const globalBroadcastMode =
        await this._channelBroadcastModeChecker.getGlobalBroadcastMode();
      if (globalBroadcastMode !== EChannelBroadcastMode.Off) {
        return this.router.navigate(
          ["/broadcasts/live/", show.broadcastPresetUid],
          {
            queryParamsHandling: "preserve",
            state: {
              fromScheduler: true,
            },
          },
        );
      } else {
        return this.router.navigate(
          ["/broadcasts/edit/", show.broadcastPresetUid],
          {
            queryParamsHandling: "preserve",
            state: {
              fromScheduler: true,
            },
          },
        );
      }
    }
  }

  openReplaceShowModal(show: Show) {
    this.ngxSmartModalService.setModalData(
      { show: show, channelFramerate: this.channelFramerate },
      "replaceShowModal",
      true,
    );

    const call = () => {
      this.ngxSmartModalService.getModal("replaceShowModal").open();
    };
    const playingItem = this.getCurrentlyPlayingItem();
    if (
      playingItem &&
      (show.id === playingItem.id || show.startTime.isSameOrBefore(moment()))
    ) {
      this.ui.globalNotify(this.ui.EVENTS.ChangePlayingItem, call, null);
      return;
    } else {
      call();
    }
    this.changeDetectorRef.markForCheck();
  }

  openRenameModal(show: Show) {
    this.ngxSmartModalService.setModalData(
      {
        showId: show.id,
        oldName: show.name,
      },
      "renameShowModal",
      true,
    );
    this.ngxSmartModalService.getModal("renameShowModal").open();
    this.changeDetectorRef.markForCheck();
  }

  async openChannelFuturePreview(show: Show) {
    if (this.futurePreviewViewModel) {
      this.futurePreviewViewModel.closeWindow();
      this.futurePreviewViewModel.showWindow();
      await this.futurePreviewViewModel.setShow(
        show.clone(),
        this.channelTimezone,
      );

      this.changeDetectorRef.markForCheck();
      this.changeDetectorRef.detectChanges();
    }
  }

  trackByShowAndEmptyFn(index, item) {
    const itemAfter =
      item.order !== this.shows.length - 1 ? this.shows[index + 1] : undefined;
    return `${item.id}-${item.endTime.valueOf()}-${itemAfter ? itemAfter.id : ""}-${itemAfter ? itemAfter.startTime.valueOf() : ""}`;
  }
  generateShowSectionStyle(show) {
    const result = show.cssStyles || {};
    const index: number = show.order;
    if (result["border"]) {
      if (
        index > 0 &&
        this.shows[index - 1].cssStyles &&
        this.shows[index - 1].cssStyles?.["border"] &&
        this.shows[index - 1].cssStyles?.["border"] === result["border"] &&
        this.hasEmptyBetweenMovies(index - 1) == false
      ) {
        // avoid duplicate borders
        result["border-top"] = "none";
      }
    }
    if (this.isAtTime(index, false)) {
      let precentage = 0;
      const show = this.shows[index];
      const isLiveShow = this.isLive(show);
      const isLongShow = this.isLongMedia(index);
      let foreground, background;

      if (isLiveShow) {
        foreground = "#DB9393";
        background = "#ffcccc";
      } else {
        foreground = isLongShow
          ? Color(this.tenantSettings.LongShowColorHex).darken(0.2).hex()
          : "#aee5ff";
        background = !isLongShow
          ? "transparent"
          : this.tenantSettings.LongShowColorHex;
      }

      if (!this.duringSkipToShow()) {
        try {
          const startTime = show.startTime.unix();
          const duration = show.duration.asSeconds();
          precentage = ((this.currentTime.unix() - startTime) / duration) * 100;
          precentage = precentage < 0 ? 0 : precentage;
          precentage = precentage > 100 ? 100 : precentage;
        } catch {}
      }
      result["background"] =
        `linear-gradient(90deg, ${foreground} ${precentage}%, ${background} 0%)`;
    }
    return result;
  }

  calculateShowRemainingTime(show: Show) {
    if (
      this.isAtTime(this.shows.indexOf(show), false) &&
      !this.duringSkipToShow()
    ) {
      return this.calendarService.getCurrentShowRemainingTime();
    }
    return show.duration;
  }

  duringSkipToShow() {
    // hacky! remove if skip ui hack is no longer needed.)
    return this.calendarService.DuringSkip;
  }

  onsearchResultHighlightedUpdated(showId: string) {
    const show = this.calendarService.getShowById(showId);
    if (show) {
      this.validateCurrentViewAndHiglightedItemMatch(show.startTime);
    }
  }

  validateCurrentViewAndHiglightedItemMatch(date: moment.Moment) {
    if (
      !date.isBetween(this.currentView.fromDate(), this.currentView.toDate())
    ) {
      this.currentDateChange.emit({
        currentDate: moment.tz(date, this.channelTimezone),
      });
    } else {
      const listBeforeNow = this.shows.filter((x) =>
        x.endTime.isSameOrBefore(date),
      );
      this.scrollToShow(listBeforeNow);
    }
  }

  updateNumShowsExpandedProperty(showExpanded) {
    if (showExpanded) {
      this.numShowsExpanded += 1;
    } else {
      this.numShowsExpanded -= 1;
    }
  }

  expandAllShowsToggle() {
    const shouldExpand = this.numShowsExpanded === 0;
    this.numShowsExpanded = shouldExpand ? this.shows.length : 0;
    this.shows.forEach((show) => (show["expanded"] = shouldExpand));
  }

  isShowPlaying(show) {
    return (
      show.startTime <= this.currentTime && show.endTime > this.currentTime
    );
  }

  secEventTypeExists(secEvents, secEventType: SecEventType) {
    return secEvents.some((event) => event.type === secEventType);
  }

  async onAddSecEventDrop(event: DragEvent, showId, secEventVisible) {
    return;
    if (secEventVisible) {
      return;
    }

    const draggedMedia = event.dataTransfer.getData("text/media")
      ? JSON.parse(event.dataTransfer.getData("text/media"))
      : null;

    const draggedGraphic = event.dataTransfer.getData("text/graphics")
      ? JSON.parse(event.dataTransfer.getData("text/graphics"))
      : null;

    const draggedMarker = event.dataTransfer.getData("text/markers")
      ? JSON.parse(event.dataTransfer.getData("text/markers"))
      : null;

    if (!draggedMedia && !draggedGraphic && !draggedMarker) {
      return;
    }

    try {
      if (!!draggedMedia) {
        await this.secEventsService.createEvent(
          showId,
          SecEventCategory.FloatingMedia,
          draggedMedia.id,
        );
      } else if (!!draggedGraphic && !draggedGraphic.isTemplate) {
        await this.secEventsService.createEvent(
          showId,
          SecEventCategory.Graphics,
          draggedGraphic.name,
        );
      } else if (!!draggedMarker) {
        // @TODO
      }
    } catch (error) {
      this.ui.notify(this.ui.EVENTS.ShowAlert, {
        title: "error creating new sec event",
        message: error.message,
      });
    } finally {
      // this._isLoading = false;
    }
  }

  onAddSecEventDragOverPlusIcon(event, showOrder, showExpanded) {
    if (showExpanded) {
      return;
    }

    if (
      event.dataTransfer.types.includes("text/show") ||
      event.dataTransfer.types.includes("text/graphics") ||
      event.dataTransfer.types.includes("text/markers") ||
      event.dataTransfer.types.includes("text/media")
    ) {
      event.preventDefault();
    }
  }

  newSecEventsDragEnter(showOrder) {
    this.shows[showOrder]["isHovering"] = true;
    this.changeDetectorRef.markForCheck();
  }

  onAddSecEventDragLeave(showOrder) {
    this.shows[showOrder]["isHovering"] = false;
    this.changeDetectorRef.markForCheck();
  }

  onAddSecEventDragEnterPlusIcon(showOrder) {
    this.shows[showOrder]["addSecEventHovering"] = true;
    this.changeDetectorRef.markForCheck();
  }

  onAddSecEventDragLeavePlusIcon(showOrder) {
    this.shows[showOrder]["addSecEventHovering"] = false;
    this.changeDetectorRef.markForCheck();
  }

  onAddSecEventBox(event, showOrder) {
    event.preventDefault();
  }

  expandAndScrollToShow() {
    if (this.fromSecEventsPopup.fromPopup) {
      const showIndex = this.shows.findIndex((element, index) => {
        if (element.id === this.fromSecEventsPopup.showId) {
          return true;
        }
      });
      this.shows[showIndex]["expanded"] = true;
      const listBeforeShow = this.shows.filter((x, index) => index < showIndex);
      setTimeout(() => this.scrollToShow(listBeforeShow), 100);
    }
  }
  public isChooseSegmentMenuVisible(item: Show): boolean {
    return (
      item.isAnchored == false &&
      item instanceof MediaShow &&
      !this.copyShowsViewModel.isMultiplySelection
    );
  }
  public async updateCurrentShowWithSegment(
    segments: MediaSegment[],
    calendarItem: CalendarItem,
  ) {
    if (segments && segments.length > 0) {
      const segment = segments[0];
      const show = calendarItem.show as MediaShow;
      const durationMs = segment.timeOutMs - segment.timeInMs;

      await this.showRepository.updateShowSom(show.id, segment.timeInMs, false);
      await this.showRepository.updateShowDuration(show.id, durationMs, false);
      let newShowName = "";
      const media = await this.mediaRepository.getMediaInfo(show.mediaId);
      if (segment.tenantUniqueId) {
        newShowName = `${media.name}, Segment ID: ${segment.tenantUniqueId}`;
      } else {
        newShowName = media.name;
      }
      await this.showRepository.renameShow(show.id, newShowName, true);
    }
  }

  createBlockClicked(item: Show) {
    const selectedShows = this.shows.filter((x) => (x as any).selected);
    if (
      item instanceof BroadcastPresetShow ||
      selectedShows.some((x) => x instanceof BroadcastPresetShow)
    ) {
      this.ui.notify(this.ui.EVENTS.ShowAlert, {
        title: "Error",
        message: "Broadcast presets can't be scheduled in a block!",
      });
      return;
    }
    let fromDate;
    let toDate;
    if (selectedShows && selectedShows.length > 0) {
      fromDate = selectedShows[0].startTime.clone();
      toDate = selectedShows[selectedShows.length - 1].endTime.clone();
    } else {
      fromDate = item.startTime.clone();
      toDate = item.endTime.clone();
    }
    this.ngxSmartModalService.setModalData(
      {
        sourceChannelId: this._currentChannel.id,
        fromTime: fromDate,
        toTime: toDate,
      },
      "createBlockModal",
      true,
    );
    this.ngxSmartModalService.getModal("createBlockModal").open();
  }

  chooseSegmentClickedEventHandler(item: MediaShow) {
    this.ngxSmartModalService.setModalData(
      {
        mediaId: item.mediaId,
        onSegmentsSelectedCallback: (segments) => {
          this.updateCurrentShowWithSegment(
            segments,
            new CalendarItem([item]),
          ).then();
        },
        currentChannel: this._currentChannel,
        onDataBindEnded: () => {
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
        },
      },
      "chooseSegmentModal",
      true,
    );
    const call = () => {
      this.ngxSmartModalService.getModal("chooseSegmentModal").open();
    };
    const playingItem = this.getCurrentlyPlayingItem();
    if (
      playingItem &&
      (item.id === playingItem.id || item.startTime.isSameOrBefore(moment()))
    ) {
      this.ui.globalNotify(this.ui.EVENTS.ChangePlayingItem, call, null);
      return;
    } else {
      call();
    }
    this.changeDetectorRef.markForCheck();
  }
  private mediaItemWithSegmentsDraggedEventHandler(
    startTime: moment.Moment,
    media: MediaInfo,
  ) {
    this.ngxSmartModalService.setModalData(
      {
        mediaId: media.id,
        onSegmentsSelectedCallback: (segments) => {
          this._createMediaShowsFromSegments(startTime, segments, media).then();
        },
        currentChannel: this._currentChannel,
        allowMultiSelect: true,
        onDataBindEnded: () => {
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
        },
      },
      "chooseSegmentModal",
      true,
    );
    this.ngxSmartModalService.getModal("chooseSegmentModal").open();
    this.changeDetectorRef.markForCheck();
  }
  private async _createMediaShowsFromSegments(
    startTime: moment.Moment,
    segments: MediaSegment[],
    media: MediaInfo,
  ) {
    let currentStartTime = startTime;
    if (segments && segments.length > 0) {
      for (let i = 0; i < segments.length; i++) {
        const segment = segments[i];
        const durationMs = segment.timeOutMs - segment.timeInMs;
        let newShowName = "";
        if (segment.tenantUniqueId) {
          newShowName = `${media.name}, Segment ID: ${segment.tenantUniqueId}`;
        } else {
          newShowName = media.name;
        }
        await this.showRepository.createMediaShow(
          media.id,
          currentStartTime,
          segment.timeInMs,
          durationMs,
          newShowName,
        );
        currentStartTime = currentStartTime.add(durationMs, "milliseconds");
      }
    }
  }

  showClicked(show: any, event: PointerEvent) {
    this.copyShowsViewModel.showClickedEventHandler(show, this.shows, event);
  }

  isItemSelected(item: any) {
    //console.log('calendar-list->isItemSelected', item.selected && this.shows && this.shows.filter(x => (x as any).selected).length > 1);
    const select = item.selected;

    return (
      select &&
      this.shows &&
      this.shows.filter((x) => (x as any).selected).length > 0
    );
  }

  isItemNotSelected(item: any) {
    return !this.isItemSelected(item);
  }
  getCurrentlyPlayingItem() {
    return this.shows.find((x) => this.isAtTime(x.order, false));
  }
  isReplaceShowMenuVisible(item: Show) {
    return (
      item.isAnchored == false &&
      this.copyShowsViewModel.isMultiplySelection == false
    );
  }

  changeAnchorState(item: Show) {
    this.showApi.updateShowAnchorState(item.id, !item.isAnchored);
  }
  showAnchorMenuItemText(item: Show) {
    return `${item.isAnchored ? "Una" : "A"}nchor Show`;
  }

  private _checkIfElementUpdate(element: HTMLElement): boolean {
    return (
      !element["_lastInnerText"] ||
      element["_lastInnerText"] !== element.innerText
    );
  }
}
